import Moment from "moment";

function getFirstDateOfTheMonth(): string {

    const now = new Date()

    return Moment(new Date(now.getFullYear(), now.getMonth(), 1)).format('YYYY-MM-DD')
}

export default getFirstDateOfTheMonth